export default __webpack_public_path__ + "static/media/Placement-Stats-19-20.33109b3f.pdf";